"use client";

import React from "react";
import { Box } from "@mui/material";
import { useIsVariant } from "@/hooks/useVariant";
import Image from "next/image";

/**
 * Default Sidebar Logo Component (NADA/ATD/CADA variants)
 */
export default function SidebarLogo() {
    const isATD = useIsVariant("atd");
    const isCada = useIsVariant("cada");

    return (
        <Box>
            {isCada ? (
                <a
                    style={{ height: 60, display: "block" }}
                    href="https://cadaworkforcestudy.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Image
                        src="/CADA_sidebar.png"
                        alt="CADA Logo"
                        width={500}
                        height={500}
                        style={{ width: "100%", height: "100%" }}
                    />
                </a>
            ) : (
                <a
                    style={{ height: 46, display: "block" }}
                    href={isATD ? "https://www.nada.org/atd" : "https://www.nada.org"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Image
                        src={isATD ? "/atd-logo.png" : "/nada-logo.webp"}
                        alt={isATD ? "ATD Logo" : "NADA Logo"}
                        style={{ width: "100%", height: "100%" }}
                        width={500}
                        height={500}
                    />
                </a>
            )}
        </Box>
    );
}
